import { getData, postData } from '@/utils/http'; 
export default {
  namespaced: true,
  state: {
    detailId: '',
    name: '',
    appKey: '',
    tableLoading: true,
    addLoading: false,
    activeItem: {},
    tableList: [],
    tableData: [],
  },
  mutations: {
    CHANGE_ACTIVE_ITEM(state, item) {
      state.activeItem = item;
    },
    CHANGE_DETAIL_ID(state, value) {
      state.detailId = value;
    },
    CHANGE_TABLE_LOADING(state, tableLoading) {
      state.tableLoading = tableLoading;
    },
    CHANGE_ADD_LOADING(state, addLoading) {
      state.addLoading = addLoading;
    },
    CHANGE_TABLE_DATA(state, data) {
      state.tableList = data; 
    },
    CHANGE_SEARCH_COLL(state, changeData) {
      if (
        changeData['changeKey'] == 'orgId' &&
        typeof changeData['data'] != 'object'
      ) {
        state[changeData['changeKey']] = [changeData['data']];
      } else {
        state[changeData['changeKey']] = changeData['data'];
      }
    }, 
    CHANGE_IS_REVIEW(state, value) {
      state.isVerify = value;
    },
  },
  actions: {
    //获取列表

    getList({ commit }) {
      return new Promise((resolve) => {
        getData('mobile/menu/tree').then((res) => {
          if (res.state == 1) {
            commit('CHANGE_TABLE_DATA', res.data);
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    // 权限保存
    save({}, data) {
      return new Promise((resolve) => {
        postData('mobile/menu/save', data).then((res) => {
          if (res.state == 1) { 
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    // 权限状态更新
    updateStatus({}, id) {
      return new Promise((resolve) => {
        getData(`mobile/menu/update/status?id=${id}`).then((res) => {
          if (res.state == 1) {
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    // 权限删除
    remove({}, id) {
      console.log(id)
      return new Promise((resolve) => {
        getData(`mobile/menu/delete?id=${id}`).then((res) => {
          if (res.state == 1) {
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    //写入查询条件
    setSearchData({ commit }, changeData) {
      commit('CHANGE_SEARCH_COLL', changeData);
    },

    //修改添加loading
    changeAddLoading({ commit }, value) {
      commit('CHANGE_ADD_LOADING', value);
    },
    //修改添加loading
    changeListLoading({ commit }, value) {
      commit('CHANGE_TABLE_LOADING', value);
    },
    setActiveItem({ commit }, item) {
			commit("CHANGE_ACTIVE_ITEM", item)
		},
  },
};
